import {whereToStayIcon, thingsToDoIcon, eatAndDrinkIcon, festivalsIcon, mapOptions} from './map-helpers.js';
const mapScript = {
  init () {

    if ($('#map').length) {
      let data = [];

      $('.marker').each(function(){
        let lat = $(this).data('lat');
        let lng = $(this).data('lng');
        let slug =  $(this).data('slug');
        let mapcat = $(this).data('cat');
        let dataObject = {
        'lat': lat,
        'lng': lng,
        'slug': slug,
        'mapcat': mapcat,
        }
        data.push(dataObject);
      });

      var maplat = "52.2600128";
      var maplng = "-7.107122";

      var vanillaMapLatLng = new google.maps.LatLng(parseFloat(52.2600128), parseFloat(-7.107122));

      function initMap() {
        var map = new google.maps.Map(document.getElementById('map'), {
          center: vanillaMapLatLng,
          options: mapOptions
        });

        // Save Markers by location
        let markerList = [];

        // Checks every place
        for (var i = 0; i < data.length; ++i) {
          var place = data[i];
          var latLng = new google.maps.LatLng(place.lat, place.lng);
          let target = '#'+place.slug;
          // Creates the marker and save it in place marker list
          var marker = new google.maps.Marker({
            position: latLng,
            link: place.slug,
            cat: place.mapcat
          });

          // console.log(markerList);
          markerList.push(marker);

        }

        map.markers = markerList;

        $(markerList).each(function(i, marker){

          marker.addListener('click', () => {
            window.open('https://maps.google.com/?q=' + latLng, '_blank');
          })

          if (marker.cat == 'where-to-stay') {
            marker.setIcon(whereToStayIcon);
          }
          if (marker.cat == 'things-to-do') {
            marker.setIcon(thingsToDoIcon);
          }
          if (marker.cat == 'eat-drink') {
            marker.setIcon(eatAndDrinkIcon);
          }
          if (marker.cat == 'festival') {
            marker.setIcon(festivalsIcon);
          }
        });


        var clusterStyles = [
          {
            textColor: 'white',
            url: 'https://dev.visitwaterford.ie/wp-content/themes/visitwaterford/assets/images/SVG/Cluster.svg',
            height: 67,
            width: 68,
            textSize:15,
          },
        ];

        var markerCluster = new MarkerClusterer(map, markerList, {
          imagePath: 'https://googlemaps.github.io/js-marker-clusterer/images/m',
          styles: clusterStyles
        });

        // center map
        center_map( map );
      }

      initMap();
    }

    // Center Map based on markers
    function center_map( map ) {

      // vars
      var bounds = new google.maps.LatLngBounds();

      // loop through all markers and create bounds
      $.each( map.markers, function( i, marker ){

        var latlng = new google.maps.LatLng( marker.position.lat(), marker.position.lng() );

        bounds.extend( latlng );

      });

      // only 1 marker?
      if( map.markers.length == 1 ) {
        // set center of map
        map.setCenter( bounds.getCenter() );
        map.setZoom( 13 );
      } else {
        // fit to bounds
        map.fitBounds( bounds );
        map.setCenter( bounds.getCenter() );
        map.setZoom( 6 );
      }

    }

    if ($('#contact-map').length) {

      let cmaplat =  $('#contact-map').data('lat');
      let cmaplng =  $('#contact-map').data('lng');

      // let myLatLng = {lat: cmaplat, lng: cmaplng};
      let myLatLng = new google.maps.LatLng(cmaplat, cmaplng);

      function initContactMap() {
        var map = new google.maps.Map(document.getElementById('contact-map'), {
          center: myLatLng,
          zoom: 11,
        });
        var cmarker = new google.maps.Marker({
          position: myLatLng,
          map: map
        });
      }

      initContactMap();
    }
  }
};

export default mapScript;



// WEBPACK FOOTER //
// ./src/components/03-ui/44-maps/maps.js